jQuery(document).ready(function onMobileNavigationReady($) {
    "use strict";

    var $body = $('body');
    var $mobile_menu_button = $('.js-toggle-mobile-menu');
    var $mobile_menu_primary = $('.mobile-menu__primary');

    $mobile_menu_button.on('click', onClickMobileMenu);
    $mobile_menu_primary.find('> ul li a').on('click', onClickMobileMenuItem);

    function onClickMobileMenu() {
        $mobile_menu_button.toggleClass('burger--open');
        $body.toggleClass('mobile-menu--visible');
    }

    function onClickMobileMenuItem(e) {
        var $this = $(this);
        var $parent = $this.parent();

        if(!$parent.hasClass('menu-item-has-children')) {
            return true;
        }

        var element_width = $this.innerWidth();
        var percentage_to_the_right = Math.round(((element_width - e.clientX) / element_width) * 100);

        if(percentage_to_the_right > 15)
            return true;

        e.preventDefault();

        $this.parent().toggleClass('current-menu-item');
    }
});
